import { useRef } from "react";
import { Navbar } from "@/components/sections/Navbar";
import { Hero } from "@/components/sections/Hero";
import { About } from "@/components/sections/About";
import { Method } from "@/components/sections/Method";
import { Programs } from "@/components/sections/Programs";
import { Testimonials } from "@/components/sections/Testimonials";
import { ApplicationForm } from "@/components/sections/ApplicationForm";
import { FAQ } from "@/components/sections/FAQ";
import { Footer } from "@/components/sections/Footer";

export default function LandingPage() {
  const formRef = useRef(null);

  const scrollToForm = () =>
    formRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });

  return (
    <div className="bg-[#0A0A0A] text-white min-h-screen overflow-x-hidden">
      <Navbar onApply={scrollToForm} />
      <Hero onApply={scrollToForm} />
      <About />
      <Method />
      <Programs onApply={scrollToForm} />
      <Testimonials />
      <ApplicationForm innerRef={formRef} />
      <FAQ />
      <Footer onApply={scrollToForm} />
    </div>
  );
}
